var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader_container",attrs:{"id":"peelhuntLoader"}},[_c('div',{staticClass:"ng-star-inserted",attrs:{"id":"cover"}}),_vm._m(0),_c('span',{staticClass:"IFloaderText",domProps:{"innerHTML":_vm._s(_vm.title)}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"IFloader ng-star-inserted"},[_c('span')])
}]

export { render, staticRenderFns }